export default __webpack_public_path__ + "static/media/icon-angle-right.0ed3f81f.svg";